declare namespace $ {

	type $mol_view__sub_shm_hitalama_map_statistics_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_map_statistics_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_map_statistics_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_map_statistics_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_map_statistics_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_hitalama_map_statistics extends $mol_view {
		widgets_text( ): string
		Widgets( ): $mol_view
		map_units_text( ): string
		Map_units( ): $mol_view
		widget_units_text( ): string
		Widget_units( ): $mol_view
		lands_text( ): string
		Lands( ): $mol_view
		loading_time_text( ): string
		Loading_time( ): $mol_view
		map( ): $shm_hitalama_map
		active( ): boolean
		widgets( ): readonly($shm_hitalama_map_widget)[]
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=statistics.view.tree.d.ts.map